import { useAppSelector } from '@Hooks/ReduxHooks'

/**
 * Platform-mode flags — the single source of truth for every classic / hybrid /
 * courses-only gate. Defaults (classrooms on, courses off) apply until
 * GET /settings resolves; `settingsLoaded` lets route gates avoid a 404 flash
 * on /courses/* deep links while the flags are still in flight.
 */
export const usePlatformFlags = () => {
	const { classrooms_enabled, standalone_courses_enabled, bundles_enabled, app_wallet, settingsLoaded } = useAppSelector(s => s.settings)
	return {
		classroomsEnabled: classrooms_enabled,
		coursesEnabled: standalone_courses_enabled,
		bothEnabled: classrooms_enabled && standalone_courses_enabled,
		coursesOnly: !classrooms_enabled && standalone_courses_enabled,
		// AND-gated: bundle pages link into /courses/:label, which 404s when the
		// courses platform is off — bundles can't stand alone.
		bundlesEnabled: bundles_enabled && standalone_courses_enabled,
		/**
		 * The wallet PRODUCT: balance surfaces and the recharge flow.
		 *
		 * NOT a payment gate — paying with an existing balance (or a scratch
		 * card) stays driven by each product's own `payment_methods_allowed`,
		 * so a platform with the wallet switched off can still sell through
		 * whatever methods admin enabled.
		 */
		walletEnabled: !!app_wallet,
		settingsLoaded,
	}
}

export default usePlatformFlags
